export type ShipEventData = {
  destination_point: string;
};

export const ship_ga4Event = (shipData: ShipEventData) => {
  dataLayer.push({
    event: 'ga4Event',
    event_name: 'ship_configurator',
    ...shipData,
  });
};
